import { BusinessAutomationActionTypeEnum } from '@reach/shared-types/business-automation';
import { Mail } from 'lucide-react';
import React, { useContext, useState } from 'react';
import { AutomationEditorContext } from '../AutomationEditorContext';
import { Step } from '../Step';
import {
  type ActionSetupField,
  type SendCommunicationAction,
  checkActionNeedsSetup,
} from '../actionSetupValidation';
import { SendMessageDialog } from './SendMessageDialog';

interface SendMessageStepProps {
  index: number;
}

function joinSetupFields(fields: ActionSetupField[]): string {
  if (fields.length <= 1) return fields.join('');
  return `${fields.slice(0, -1).join(', ')} and ${fields[fields.length - 1]}`;
}

function getIncompleteSubtitle(remainingSetup: ActionSetupField[]): string {
  return `Add ${joinSetupFields(remainingSetup)} to finish setup`;
}

function getSubjectLine(action: SendCommunicationAction): string {
  return action.subject?.trim() || 'Message configured';
}

export const SendMessageStep: React.FC<SendMessageStepProps> = ({ index }) => {
  const { editor } = useContext(AutomationEditorContext)!;
  const { state } = editor;
  const [isDialogOpen, setIsDialogOpen] = useState(false);

  const action = state.localContents.actionData?.[index];
  if (!action || action.type !== BusinessAutomationActionTypeEnum.SEND_COMMUNICATION) {
    return null;
  }

  const remainingSetup = checkActionNeedsSetup(action);
  const subtitle = remainingSetup ? getIncompleteSubtitle(remainingSetup) : getSubjectLine(action);

  return (
    <>
      <Step
        index={index}
        icon={Mail}
        title="Send Message"
        subtitle={subtitle}
        needsSetup={!!remainingSetup}
        onConfigure={() => setIsDialogOpen(true)}
      />
      {isDialogOpen && (
        <SendMessageDialog onClose={() => setIsDialogOpen(false)} action={action} actionIndex={index} />
      )}
    </>
  );
};
